import React from 'react';
import PropTypes from 'prop-types';
import './NgPayment.scss';

const NgPayment = () => {
  return (
    <div className="main-right-side-section">
      <div className="ngpayment-main-section">
        <section>
          <div className="ngpayment-section-1">
            <div className="ngpayment-section-1-inner">
              <p>Payment Integration</p>
            </div>
          </div>
        </section>
      </div>
    </div>
  )
}

NgPayment.propTypes = {};

NgPayment.defaultProps = {};

export default NgPayment;
